import mixin_work from "../../mixins/mixin_work";

export default {
  mixins: [mixin_work],
  props: {
    work: [Array, Object],
    wimg: [Number],
    is_mark_work_pro: [Boolean],
  },
  data() {
    return {
      is_editable_works: ($('#app-wrapper').attr('is_editable_works')==1),//юзер-владелец может добавлять/редактировать
      is_editor: ($('#app-wrapper').attr('is_editor')==1),//наш редактор/модератор
      to_set_type: $('#app-wrapper').attr('set_type'),
    }
  },
  methods : {
    is_show_cost(work){
      return true;
    },

    is_show_controls(){
      if ( window._GL_works_show_menu==='n' ) return false;
      return true;
    },

    is_show_artist(cur_artist_id){
      let artist_id=$('#app-wrapper').attr('artist_id');
      if ( artist_id!=null && artist_id.length>0 && artist_id==cur_artist_id ) return false;
      return true;
    },
  },
  computed : {
    works_without_artist: {
      get () {
        return (window._GL_works_without_artist!=='y');
      }
    },

    is_show_slideshow: {
      get(){
        if ( window._GL_works_without_slideshow=='y' ) return false;
        else return true;
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/WorksItemMix.js
// module id = null
// module chunks = 